/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseEntity} from './base-entity';

export class Event extends BaseEntity {
  type: string;
  category1: string;
  category2: string;
  category3: string;
  glyph: string;
  locked: boolean;  
}
